import SuperAdminSettings from './SuperAdminSettings';
export default SuperAdminSettings;
